import { useContext } from "react";
import { PendingFormsContext } from "./state";

export function usePendingFormsContext() {
  return useContext(PendingFormsContext);
}
